
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.54 9.595a2 2 0 000-3.19 1.196 1.196 0 01-.198-.19c-.177-.214-.27-.487-.185-.75.114-.35.495-.548.816-.367.129.073.253.154.371.244m0 0A3.337 3.337 0 0112.667 8a3.334 3.334 0 01-1.694 2.903c-.32.18-.702-.016-.816-.367-.085-.263.008-.537.184-.75a1.172 1.172 0 01.199-.19","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.925 11.507a3.999 3.999 0 00-.075-7.053l-.003-.001a.864.864 0 01-.138-.091c-.239-.192-.364-.504-.267-.8.114-.35.492-.546.825-.389a5.32 5.32 0 012.048 1.692 5.333 5.333 0 01-2.048 7.963c-.333.156-.711-.04-.825-.39-.097-.296.028-.607.267-.8a.849.849 0 01.138-.09l.003-.001.075-.04zM4 10c.323 0 .635.118.878.33L8 13.062V2.939L4.878 5.67C4.635 5.883 4.323 6 4 6H2.666A.667.667 0 002 6.667v2.667c0 .368.298.666.666.666H4zm0 1.334l3.122 2.731c.862.755 2.211.143 2.211-1.003V2.939c0-1.146-1.35-1.758-2.211-1.004L4 4.667H2.666a2 2 0 00-2 2v2.667a2 2 0 002 2H4z","fill":"currentColor"}})])
          )
        }
      }
    